'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M16 48l0 416 416 0 0-313.4L329.4 48 320 48l0 136c0 4.4-3.6 8-8 8L72 192c-4.4 0-8-3.6-8-8L64 48 16 48zM312 328a88 88 0 1 1 -176 0 88 88 0 1 1 176 0z', 'M16 480L0 480l0-16L0 48 0 32l16 0 320 0L448 144l0 320 0 16-16 0L16 480zm416-16l0-313.4L329.4 48 320 48l0 136c0 4.4-3.6 8-8 8L72 192c-4.4 0-8-3.6-8-8L64 48 16 48l0 416 416 0zM80 48l0 128 224 0 0-128L80 48zm72 280a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zm72 88a88 88 0 1 1 0-176 88 88 0 1 1 0 176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;